import { ArrowRight } from "lucide-react";
import { createPortal } from "react-dom";
import { toDayMonth } from "@/shared/utils/date";
import type { AbsenceTooltipState } from "./useAbsenceTooltip";

// Cursor-following card, portaled to <body> so the grid's scroll container can't clip it. Outer owns
// positioning (fixed + translate) and pointer-events-none so it never intercepts the mouse moves that
// drive it; inner owns the enter animation, separate so its transform doesn't fight the positioning one.
// The `-50%`/`-100%` translate is relative to the card's own size, so no measuring.
export function FloatingAbsenceTooltip({ absence, x, y }: AbsenceTooltipState) {
  return createPortal(
    <div
      className="pointer-events-none fixed left-0 top-0 z-50 w-fit"
      style={{
        transform: `translate(calc(${x}px - 50%), calc(${y}px - 100% - 10px))`,
      }}
    >
      <div className="w-fit rounded-md bg-foreground px-3 py-1.5 text-xs text-background animate-in fade-in-0 zoom-in-95">
        <p className="font-medium">{absence.reason}</p>
        <p className="inline-flex items-center gap-1 text-xs text-muted-foreground">
          {absence.startDate === absence.endDate ? (
            toDayMonth(absence.startDate)
          ) : (
            <>
              {toDayMonth(absence.startDate)}
              <ArrowRight className="size-3" aria-hidden />
              {toDayMonth(absence.endDate)}
            </>
          )}
        </p>
      </div>
    </div>,
    document.body,
  );
}
